import { Link, useLocation } from 'react-router-dom';
import { Globe } from 'lucide-react';

// Maps CZ ↔ EN URLs for translated marketing pages.
const CZ_TO_EN: Record<string, string> = {
  '/': '/en',
  '/syndicates': '/en/syndicates',
  '/o-nas': '/en/about',
};
const EN_TO_CZ: Record<string, string> = {
  '/en': '/',
  '/en/syndicates': '/syndicates',
  '/en/about': '/o-nas',
};

export const LanguageSwitcher = ({ variant = 'header' }: { variant?: 'header' | 'inline' }) => {
  const location = useLocation();
  const path = location.pathname.replace(/\/$/, '') || '/';
  const isEn = path === '/en' || path.startsWith('/en/');
  const target = isEn ? EN_TO_CZ[path] : CZ_TO_EN[path];

  if (!target) return null;

  const baseClass =
    variant === 'header'
      ? 'inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md text-xs font-medium bg-white/10 text-white hover:bg-white/20 transition-colors'
      : 'inline-flex items-center gap-1.5 text-sm text-primary hover:underline';

  return (
    <Link to={target} className={baseClass} aria-label={isEn ? 'Přepnout do češtiny' : 'Switch to English'}>
      <Globe className="h-3.5 w-3.5" />
      {isEn ? 'CZ' : 'EN'}
    </Link>
  );
};
